import { render, staticRenderFns } from "./PageMultiPillSelect.vue?vue&type=template&id=0f869df0"
import script from "./PageMultiPillSelect.vue?vue&type=script&lang=js"
export * from "./PageMultiPillSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports